var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOffice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 14,
    viewBox: "0 0 21 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.68325 7.6369C4.45614 7.6369 0 8.75094 0 10.9781V13.3636H13.3656V10.9781C13.3656 8.75094 8.91132 7.6369 6.68325 7.6369ZM14.3204 7.6369C14.0426 7.6369 13.7314 7.65409 13.3982 7.68845C14.5037 8.48842 15.274 9.56236 15.274 10.9781V13.3636H21.0008V10.9781C21.0008 8.75094 16.5475 7.6369 14.3204 7.6369ZM6.68458 -0.000976562C5.10374 -0.000976562 3.82073 1.28298 3.82073 2.86382C3.82073 4.44466 5.10374 5.72766 6.68458 5.72766C8.26637 5.72766 9.53983 4.44466 9.53983 2.86382C9.53983 1.28298 8.26637 -0.000976562 6.68458 -0.000976562ZM14.3229 -0.000976562C12.7402 -0.000976562 11.4581 1.28298 11.4581 2.86382C11.4581 4.44466 12.7402 5.72766 14.3229 5.72766C15.9037 5.72766 17.1762 4.44466 17.1762 2.86382C17.1762 1.28298 15.9037 -0.000976562 14.3229 -0.000976562Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffice);
export default __webpack_public_path__ + "static/media/office.63a66225.svg";
export { ForwardRef as ReactComponent };